module.exports = __webpack_public_path__ + "img/Bent Link.9ace4874.png";